import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/pagina-nao-encontrada.svg'


const _hoisted_1 = { class: "error-404-view" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Contact = _resolveComponent("Contact")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"container\"><div class=\"title-error-view col-12\"><h1 class=\"col-12\">Ops! Página não encontrada.</h1><p class=\"col-12\"> A página que você procura não foi encontrada ou não existe. </p></div><div class=\"imagem-error-view col-12 my-2\"><img alt=\"Página não encontrada\" src=\"" + _imports_0 + "\"></div><div class=\"description-error-view col-12\"><p>Aproveite este momento pra fazer uma pausa e tomar um café!</p></div></div>", 1)),
    _createVNode(_component_Contact)
  ]))
}